import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TDetailedPolygonsSliceState, DETAILED_POLYGONS, TDetailedPolygons } from '../mapTypes';
import { RootState } from '../../../core/store';

const initialState: TDetailedPolygonsSliceState = {
    detailedPolygonsData: null,
    detailedPolygonsLoading: false,
    detailedPolygonsError: null,
};

const detailedPolygonsSlice = createSlice({
    name: DETAILED_POLYGONS,
    initialState,
    reducers: {
        getDetailedPolygonsRequestAction: (state: TDetailedPolygonsSliceState, _: PayloadAction) => {
            state.detailedPolygonsLoading = true;
            state.detailedPolygonsError = null;
        },
        getDetailedPolygonsSuccessAction: (state: TDetailedPolygonsSliceState, { payload: data }: PayloadAction<TDetailedPolygons>) => {
            state.detailedPolygonsLoading = false;
            state.detailedPolygonsData = data;
            state.detailedPolygonsError = null;
        },
        getDetailedPolygonsErrorAction: (state: TDetailedPolygonsSliceState,  { payload: error }: PayloadAction<any>,) => {
            state.detailedPolygonsData = null;
            state.detailedPolygonsLoading = false;
            state.detailedPolygonsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
    },
});

export const detailedPolygonsActions = {
    ...detailedPolygonsSlice.actions
};

export default detailedPolygonsSlice.reducer;

export const selectDetailedPolygons = (state: RootState) => state.detailedPolygonsSlice.detailedPolygonsData!;